import React from "react";
import styled from "styled-components";
import { read_timeline_note_label } from "../../utils/timeline/timeline_formatting";

const TimelineComment = styled.div`
    p {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

// Displays the safe plain-text body of a regular or SASS comment.
export const Timeline_Comment = (props) => {
    return (
        <TimelineComment>
            <p>{read_timeline_note_label(props.event)}</p>
        </TimelineComment>
    );
};
